import React, { type FunctionComponent } from 'react'
import { PageHeader } from '@retailer-platform/shared-components'
import { AccountManagementCreateAccount } from 'domains/account-management/components/account-create/AccountManagementCreateAccount'
import DocumentTitle from 'legacy/components/DocumentTitle'
import { accountManagementWrapperStyles } from 'domains/account-management/styles/accountManagement.styles'
import { RetailerTerminology } from 'domains/account-management/components/account-form/utils/AccountForm.types'
import { CreateAccountBreadcrumbs } from 'domains/account-management/components/account-create/components/breadcrumbs/CreateAccountBreadcrumbs'
import { useCreateAccountQueryParams } from 'domains/account-management/utils/useCreateAccountQueryParams.hooks'

export const AccountManagementCreateAccountPage: FunctionComponent = () => {
  const { preselectRole } = useCreateAccountQueryParams()

  return (
    <div css={accountManagementWrapperStyles}>
      <DocumentTitle titleId="accountManagementDomain.create.pageTitle" />
      <PageHeader title={<CreateAccountBreadcrumbs />} />

      <AccountManagementCreateAccount
        showAllPartnersFullAccessToggle={true}
        retailerTerminology={RetailerTerminology.InternalTerms}
        preselectRoleId={preselectRole}
      />
    </div>
  )
}
